import "./WelcomePage.scss";
import ProgramsTaps from "./components/ProgramsTaps";
import NavBar from "./components/NavBar";
import { useTranslation } from "react-i18next";
import LoadingOverlay from "../../components/blocks/LoadingOverlay";
import {useQuery} from "../../hooks/useQuery";
import {BackendServices} from "../../services";
import {useCookieContext} from "../../contexts";
import React from "react";
import {SafeHtmlRenderer} from "../../components/safeHtmlRendererComponant/SafeHtmlRenderer";


const WelcomePageView = () => {
  const { t } = useTranslation("WelcomePage");
  const { isAr } = useCookieContext();
  
  
  const { data:welcomeWidget , loading: welcomeWidgetLoading } = useQuery({
    queryFn: async () => {
      return await BackendServices.widgetService.GetWidgetByReferenceId(process.env.REACT_APP_WELCOME_WIDGET);
    },
    triggers: [isAr],
  });

  const { data:headerWidget , loading: headerWidgetLoading } = useQuery({
    queryFn: async () => {
      return await BackendServices.widgetService.GetWidgetByReferenceId(process.env.REACT_APP_FUNDING_HEADER_PART_WIDGET);
    },
    triggers: [isAr],
  });
  return (
    <div className="w-100 bg-white d-flex flex-column">
       <LoadingOverlay visible={welcomeWidgetLoading || headerWidgetLoading} />
      <div className="welcome-container text-white d-flex flex-column justify-content-between py-4 px-4rem ">
        <NavBar />
        <div className=" welcome-text-container d-flex flex-column gap-4 mb-5 align-items-start">
          {welcomeWidget && <SafeHtmlRenderer htmlContent={welcomeWidget.widgetDetail.htmlTemplate} /> }
        </div>
      </div>

      {/* programs */}
      <div className="programs-container px-4rem pt-4 pb-4rem text-dark">
        {headerWidget && <SafeHtmlRenderer htmlContent={headerWidget.widgetDetail.htmlTemplate} /> }
        <ProgramsTaps />
      </div>
    </div>
  );
};

export default WelcomePageView;
